import { useEffect, useState } from "react";
import { mergeExtraContactEmails } from "@/lib/manufacturing/vendorExtraContacts";
import type { MfgPurchaseOrder } from "@/lib/manufacturing/purchaseOrderTypes";
import type { MfgVendorExtraContact } from "@/lib/manufacturing/vendorExtraContacts";

export function usePoCcEmails(active: MfgPurchaseOrder | null) {
  const [ccEmails, setCcEmails] = useState<string[]>([]);
  const [defaultPoCcEmails, setDefaultPoCcEmails] = useState<string[]>([]);
  const [defaultInvoiceCcEmails, setDefaultInvoiceCcEmails] = useState<string[]>([]);

  useEffect(() => {
    if (active) return;
    if (ccEmails.length || !defaultPoCcEmails.length) return;
    setCcEmails(defaultPoCcEmails);
  }, [active, ccEmails.length, defaultPoCcEmails]);

  function mergeFromVendorContacts(contacts: MfgVendorExtraContact[] | undefined) {
    if (!contacts?.length) return;
    setCcEmails((cur) => mergeExtraContactEmails(cur, contacts));
  }

  return {
    ccEmails,
    setCcEmails,
    defaultPoCcEmails,
    setDefaultPoCcEmails,
    defaultInvoiceCcEmails,
    setDefaultInvoiceCcEmails,
    mergeFromVendorContacts,
  };
}
